import { Component, OnInit } from '@angular/core';
import { SlInputComponent } from '@sl/sl-angular-library';
import { IHello } from '../core/impersonate/hello.model';
import { ImpersonateService } from '../core/impersonate/services/impersonate.service';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss'],
  imports: [SlInputComponent]
})
export class ImpersonateComponent implements OnInit {

  constructor(private impersonateService: ImpersonateService) { }
  public hello: string | undefined;


  ngOnInit(): void {
    this.impersonateService.helloUser().subscribe((res:IHello) => this.hello = res.message);
  }

  public switch(username: string): void {
    this.impersonateService.switchUser(username).subscribe((res:IHello) => this.hello = res.message);
  }

  public exit(): void{
    this.impersonateService.exitUser().subscribe((res:IHello) => this.hello = res.message);
  }

}